import React from 'react';
import { Row } from './Collection';
import { fmt } from '../../nucleus/format';

// AN EMPTY PAGE, OR ONE THAT FAILED: one quiet line where the content would
// stand. A failure (`error`, or a `retry` to offer) is said in the live red,
// and `retry` puts Try again after it.
export function Empty({ children, error = false, retry, className = '', ...rest }) {
    const failed = error || !!retry;
    return (
        <p className={`nx-empty${failed ? ' is-error' : ''} ${className}`.trim()} role={failed ? 'alert' : undefined} {...rest}>
            {children}
            {retry && <>{' '}<button type="button" className="nx-link" onClick={retry}>Try again</button></>}
        </p>
    );
}

// A READ THAT FAILED, said as one: what could not be read, the server's
// reason when it gave one, and Try again. Never "nothing yet" over a failure.
//   <ErrorEmpty what="your plugins" error={error} retry={reload} />
export function ErrorEmpty({ what = 'this', error, retry, className = '' }) {
    const why = error?.message && error.message !== 'Failed to fetch' ? ` ${String(error.message).replace(/\.?$/, '.')}` : '';
    return <Empty error retry={retry} className={className}>{`Couldn’t load ${what}.${why}`}</Empty>;
}

// A READ, SAID ITS ONE WAY (GRAMMAR: Loading is null): nothing while it is
// first read, ErrorEmpty when it failed, `empty` once it came back with
// nothing (`isEmpty`, by default an empty list), else `children(data)`.
//   <Loaded read={runs} what="the runs" empty="Nothing has run yet.">{(d) => <RunTable runs={d.runs} />}</Loaded>
export function Loaded({ read, what, empty = null, isEmpty, children }) {
    const { data, error, reload } = read || {};
    if (error && data == null) return <ErrorEmpty what={what} error={error} retry={reload} />;
    if (data == null) return null;
    const none = isEmpty ? isEmpty(data) : Array.isArray(data) && data.length === 0;
    if (none) return empty == null ? null : <Empty>{empty}</Empty>;
    return children(data);
}

// SHOW MORE: the row under a list read a page at a time, saying how much of it
// is here. Nothing when it is all here.
export function ShowMore({ shown, total, label = 'Show more', note, onMore, className = '' }) {
    if (shown == null || total == null || shown >= total) return null;
    return (
        <div className={`nx-rows nx-more ${className}`.trim()}>
            <Row name={label} sub={note ?? `Showing ${fmt(shown)} of ${fmt(total)}`} onPress={onMore} />
        </div>
    );
}
